import React, { useMemo } from 'react';
import NACell from '../Reusable/DataTable/NACell';
import DataTable from '../Reusable/DataTable';
import APIS from '../../constant/EndPoint';
import Button from '../Reusable/Button';
import { tw } from '@careinfo/tailwind';
import StatusSelect from '../Reusable/StatusSelect';
import { useParams } from 'react-router-dom';

const StatusList = ({ handleAsync, isLoading, statusData }: any) => {
  const optionData = statusData?.map((item) => ({
    code: item?.id ?? item?.name,
    name: item?.name,
  }));
  const {slug} = useParams<{ slug: string }>();
  const partnerName = slug?.replace(/-/g, ' ');
  const defaultColumns = [
    {
      header: 'Our Status',
      accessorKey: 'sender_status_name',
      cell: NACell,
    },
    {
      header: `${partnerName} Status`,
      accessorKey: 'receiver_status_name',
      cell: ({ row, getValue }) => {
        const selectedValue = getValue();
        return useMemo(
          () => (
            <StatusSelect
              id={row?.original?.id}
              value={selectedValue}
              options={optionData}
              slug={slug}
            />
          ),
          [selectedValue, row?.original?.id, optionData, slug]
        );
      },
    },
  ];
  return (
    <DataTable
      url={APIS.STATUS}
      queryKey={`status-${slug}`}
      columns={defaultColumns}
      tableName={'Status'}
      params={{
        delivery_partner__slug: slug,
      }}
      actionMenu={
        <div className={tw`flex w-full justify-end`}>
          <div className={tw`w-24`}>
            <Button
              label={'Sync'}
              type={'button'}
              onClick={() => handleAsync()}
              isLoading={isLoading}
            />
          </div>
        </div>
      }
    />
  );
};

export default StatusList;
